<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Preferences</h1>
                </div>
                <div class="brand-icon">
          <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
        </div>
            </div>
            <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                :ref="el => formsData.userForm.ref = el" :label-position="'top'" @submit.prevent="goNext('userForm')">
                <div class="" v-if="userRole === 'locum'">
                    <div class="menu_title">Available Days</div>
                    <el-form-item  prop="schedule" class="profile_schedule">
                        <el-checkbox v-for="(value, day) in formsData.userForm.schedule.value" :key="day"
                            v-model="formsData.userForm.schedule.value[day]">{{ $filters.capitalize(day.slice(0, 3)) }}
                        </el-checkbox>
                    </el-form-item>

                    <div class="profile_rate" v-if="userRole === 'locum'">
                        <div class="menu_title">Rate</div>
                        <div class="form_text">
                            <div class="title">Rate per hour</div>
                            <div class="text_note" v-if="isAustralia">(excluding super)</div>
                        </div>

                        <el-form-item prop="minRate">
                            <div class="el-input">
                                <input type="tel" class="input_currency el-input__inner"
                                    :ref="(el) => (formsData.userForm.minRate.ref = el)"
                                    :value="formsData.userForm.minRate.value" :placeholder="'0.00'"
                                    v-imask="formsData.userForm.minRate.mask" @accept="($event) => {
                                        onFormMaskAccept($event, 'userForm', 'minRate');
                                        checkFormValidation('userForm', true);
                                    }
                                        " @blur="checkFormValidation('userForm', true)" />
                                 <span class="currency" v-if="isAustralia">AUD</span>
                                 <span class="currency" v-else>USD</span>
                            </div>
                        </el-form-item>

                    </div>

                    <div class="profile_rate" v-if="userRole === 'locum'">
             
                        <div class="form_text">
                            <div class="title">Weekend rate per hour</div>
                            <div class="text_note" v-if="isAustralia">(excluding super)</div>
                            <div class="text_note"></div>
                        </div>
                        <el-form-item prop="weekendRate">
                            <div class="el-input">
                                <input type="tel" class="input_currency el-input__inner"
                                    :value="formsData.userForm.weekendRate.value" :placeholder="'0.00'"
                                    v-imask="formsData.userForm.minRate.mask"
                                    :disabled="formsData.userForm.weekendRate.disabled" @accept="($event) => {
                                        onFormMaskAccept($event, 'userForm', 'weekendRate');
                                        checkFormValidation('userForm', true);
                                    }
                                        " @blur="checkFormValidation('userForm', true)" />
                                 <span class="currency" v-if="isAustralia">AUD</span>
                                 <span class="currency" v-else>USD</span>
                            </div>
                        </el-form-item>
                    </div>

                    <el-form-item v-if="userRole === 'locum'">
                        <el-checkbox v-model="formsData.userForm.weekendRate.disabled"
                            @change="onNameCheckboxChange">Same as
                            Weekday rate
                        </el-checkbox>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item prop="schedule" class="job_filters_form_checkbox">
                        <div class="item-select__header">
                            <div class="menu_title">Shift Type</div>
                        </div>
                        <div class="checkbox-availability">
                            <!-- <el-checkbox class="checkbox_w100" v-for="(value, key) in formsData.userForm.shift_type.value"
                        :key="key" v-model="formsData.userForm.shift_type.value[key]">
                        {{ getCustomLabel(key) }}
                    </el-checkbox> -->

                            <el-checkbox v-for="(value, day) in formsData.userForm.shift_type.value" :key="day"
                                v-model="formsData.userForm.shift_type.value[day]">{{
                                    $filters.capitalize(day.replace(/([a-z])([A-Z])/g, '$1 $2')) }}
                            </el-checkbox>
                        </div>

                    </el-form-item>
                </div>
                <div>
                    
                    <div class="menu_title">Travel Preference</div>
                    <el-select class="select" v-model="formsData.userForm.travel_preference.value"
                        placeholder="Distance (Km)" popper-class="normal-select" @change="checkFormValidation('userForm', true)">
                        <el-option v-for="item in travelOptions" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>

                <div class="form_text mt-3">
              <div class="text text-standout">
                Are you willing to take on an assignment for a temporary period of time (1 - 13 weeks) where accommodation and travel costs are covered?
              </div>
            </div>
            <el-form-item class="button_submit mb0">
                <el-radio-group v-model="formsData.userForm.travel_assignment.value" @change="checkFormValidation('userForm', true)">
              <el-radio :label="'0'">No</el-radio>
              <el-radio :label="'1'">Yes</el-radio>
            </el-radio-group>
            </el-form-item>


                <el-form-item class="button_submit mb0">
                    <el-button class="submit" type="blue" @click="goNext('userForm')"
                    :disabled="formsData.userForm.disabled" > 
                    Continue
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
        </div>
    </div>
</template>

<script>
import {
    onMounted,
    inject,
} from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'
import {
    useRouter,
    useRoute
} from 'vue-router'
import formHooks from '@/hooks/form/form'
import formValidate from '@/hooks/form/validate/validate'
import formMasks from '@/hooks/form/mask/mask'
import { ElMessageBox } from "@/components/Vendor/Element";
import IMaskDirective from '@/directives/vue-imask/directive';
import IMask from 'imask/esm/imask';
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon
    },
    directives: {
        imask: IMaskDirective
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const $route = useRoute()
        const setPageClassGlobal = inject('setPageClassGlobal');
        const userData = $store.getters.GET_USER_DATA;
        const userRole = userData.role;
        const schedule = userData.schedule;
        const scheduleShift = userData.shiftType;
        const minRate = userData.minRate;
        const weekendRate = userData.weekendRate;
        const isAustralia = isAustraliaRegion();

        const travelOptions = [
                {
                    label: "10",
                    value: 10,
                },
                {
                    label: "25",
                    value: 25,
                },
                {
                    label: "50",
                    value: 50,
                },
                {
                    label: "100",
                    value: 100,
                },
                {
                    label: "Any",
                    value: 0,
                },
            ];


        const formsDataArray = {
            userForm: {
                schedule: {
                    value: Object.keys(schedule).reduce((value, key) => {
                        value[key] = !!parseInt(schedule[key]);
                        return value;
                    }, {}),
                    resetValue: true,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "schedule",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
                minRate: {
                    ref: {},
                    value: minRate
                        ? IMask.createMask(formMasks.rate).resolve("" + minRate)
                        : null,
                    resetValue: true,
                    mask: formMasks.rate,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "minRate",
                                    callback,
                                    setFormValidation
                                );
                            },
                            trigger: "change",
                        },
                    ],
                },
                weekendRate: {
                    ref: {},
                    valueTemp: "",
                    value: weekendRate
                        ? IMask.createMask(formMasks.rate).resolve("" + weekendRate)
                        : null,
                    resetValue: true,
                    mask: formMasks.rate,
                    disabled: (minRate === weekendRate && minRate !== null)  ? true : false,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "weekendRate",
                                    callback,
                                    setFormValidation
                                );
                            },
                            trigger: "change",
                        },
                    ],
                },
                shift_type: {
                    //if empty scheduleShift is empty, use scheduleShiftArray
                  
                    value: Object.keys(scheduleShift).reduce((value, key) => {
                     
                        value[key] = !!parseInt(scheduleShift[key]);
                        return value;
                    }, {}),
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'schedule', callback, setFormValidation);
                        },
                    }],
                },
                travel_preference: {
                    value: userData.travelPreference === "0" ? 0 : userData.travelPreference,
                    resetValue: true,
                    validators: [
                        {
                        validator: (rule, formField, callback) => {
                            formValidate.validate(
                                rule,
                                formField,
                                {
                                rule: "travelPreference",
                                },
                                callback,
                                setFormValidation
                            );
                        },
                        },
                    ],
                    },
                    travel_assignment: {
                    value: userData.travelAssignment === "0" ? "0" : (userData.travelAssignment || "0"),
                    resetValue: true,
                },
            }
        };
       
        const goBack = () => {
            $router.push({
                name: "profile_edit"
            })
        };


        const goNext = (formName) => {
            $store.dispatch('addAuthPageBack', $route.name);
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    (async () => {
                        try {
                            const data = getFormValues(formName);
                           
                            await $store.dispatch('SAVE_USER_DATA', data);
                            $router.push({
                                name: 'profile_edit',
                            })
                        } catch (error) {
                            console.log('error submit!!');
                        }
                    })();
                } else {
                    setFormValidation(formName, false, false);
                    console.log('error submit!!');
                    return false;
                }
            });
        };

        const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    $store.dispatch('addAuthPageBack', $route.name);
                    $router.push({
                        name: 'auth_insuranceProof',
                    })
                } catch (error) {
                    console.log(error);
                }
            })();

        }

        const onNameCheckboxChange = () => {
            if (formsData.userForm.weekendRate.disabled) {
                formsData.userForm.weekendRate.valueTemp =
                    formsData.userForm.weekendRate.value;
                formsData.userForm.weekendRate.value = formsData.userForm.minRate.value;
                // formsData.userForm.weekendRate.value = userData.minRate;
                formsData.userForm.weekendRate.disabled = true;
            } else {
                formsData.userForm.weekendRate.value =
                    formsData.userForm.weekendRate.valueTemp;

                formsData.userForm.weekendRate.disabled = false;
            }
            // checkFormValidation("userForm", true, "weekendRate");
            checkFormValidation("userForm", true);
        };

        const getCustomLabel = (key) => {
            // switch (key) {
            //     case 'early_morning':
            //         return 'Early morning';
            //     case 'overnight':
            //         return 'Overnight';
            //     case 'long_stay':
            //         return 'Long stay';
            //     case 'rural':
            //         return 'Rural';
            //     case 'metro':
            //         return 'Metro';
            //     default:
            //         return '';
            // }
            switch (key) {
                case 'Early Morning':
                    return 'Early morning';
                case 'Over Night':
                    return 'Over night';
                case 'Long Stay':
                    return 'Long stay';
                case 'Rural':
                    return 'Rural';
                case 'Metro':
                    return 'Metro';
                default:
                    return '';
            }
        };

        onMounted(() => {
            setPageClassGlobal('global_auth_page');
            setFormRefs();
            formsRefs.userForm.value.$el[0].focus();
            checkFormValidation('userForm', false);
        });

        const {
            onFormMaskAccept,
            checkFormValidation,
            setFormValidation,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);

        return {
            formsData,
            onFormMaskAccept,
            checkFormValidation,
            goBack,
            goNext,
            skip,
            userRole,
            onNameCheckboxChange,
            scheduleShift,
            getCustomLabel,
            travelOptions,
            isAustralia
        }
    },
}
</script>